import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-wizard-end-page',
  imports: [],
  standalone: true,
  templateUrl: './wizard-end-page.component.html'
})
export class WizardEndPageComponent {
  @Input() dshImg: string;
  @Input() noConfirmations: boolean;
  @Input() noDigitalSignatures: boolean;
}
